<template>
  <b-card
    no-body
    :class="toPage? 'link-card' : null"
    @click="goPage(toPage)"
  >
    <b-card-body>
      <b-row class="d-flex justify-content-center align-items-center">
        <b-col>
          <b-row>
            <b-col>
              <div class="truncate">
                <h2
                  class="mb-25 font-weight-bolder"
                >
                  <span v-if="prefix">{{ prefix }}</span>
                  <span>
                    {{ value | toNumber }}
                  </span>
                  <span v-if="suffix">{{ suffix }}</span>
                </h2>
                <span>{{ title }}</span>
              </div>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col>
              <div class="truncate mt-1 text-nowrap">
                <h2
                  v-if="value"
                  class="mb-25 font-weight-bolder"
                >
                  <span v-if="prefix">{{ prefix }}</span>
                  <span>
                    {{ trafficValue | toNumber }}
                  </span>
                  <span v-if="suffix">{{ suffix }}</span>
                </h2>
                <span>Trafik</span>
              </div>
            </b-col>
            <b-col>
              <div class="truncate mt-1 text-nowrap">
                <h2
                  v-if="value"
                  class="mb-25 font-weight-bolder"
                >
                  <span v-if="prefix">{{ prefix }}</span>
                  <span>
                    {{ insuranceValue | toNumber }}
                  </span>
                  <span v-if="suffix">{{ suffix }}</span>
                </h2>
                <span>Kasko</span>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="float-right text-right p-0">
          <vue-apex-charts
            type="radialBar"
            :options="supportTrackerRadialBar.chartOptions"
            :series="rate"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BCol, BRow,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  name: 'TreRatioCard',
  components: {
    BCol, VueApexCharts, BRow, BCard, BCardBody,
  },
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    trafficValue: {
      type: [String, Number],
      required: true,
    },
    insuranceValue: {
      type: [String, Number],
      required: true,
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    rateTitle: {
      type: String,
      default: '',
    },
    rate: {
      type: Array,
      default: Array,
    },
    toPage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      supportTrackerRadialBar: {
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: -10,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '50%',
              },
              track: {
                background: '#fff',
                strokeWidth: '100%',
              },
              dataLabels: {
                name: {
                  offsetY: -5,
                  color: '#5e5873',
                  fontSize: '70%',
                },
                value: {
                  offsetY: -3,
                  color: '#5e5873',
                  fontSize: '1rem',
                },
              },
            },
          },
          colors: [$themeColors.danger],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 8,
          },
          labels: [this.rateTitle],
        },
      },
    }
  },
  methods: {
    goPage(url) {
      if (url) {
        this.$router.push(url)
      }
    },
  },
}
</script>
<style>
.link-card{
  cursor: pointer !important;
}
</style>
